import { createFileRoute } from "@tanstack/react-router";
import { OffersPage } from "../components/offers/OffersPage";

export const Route = createFileRoute("/_auth/_messaging/offers")({
  staticData: { titleKey: "nav.messaging", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 7 },
  component: OffersPage,
});
